export const domainConfig = {
  imageServer: process.env.REACT_APP_IMAGES,
  eventos: process.env.REACT_APP_PLATAFORMA_EVENTOS,
  eventosAPI: process.env.REACT_APP_PLATAFORMA_EVENTOS_RESTAPI,
  eventosSocketAPI: process.env.REACT_APP_PLATAFORMA_EVENTOS_WEBSOCKETAPI,
  aplicativos: process.env.REACT_APP_PLATAFORMA_APLICATIVOS,
  aplicativosAPI: process.env.REACT_APP_PLATAFORMA_APLICATIVOS_API,
  restAPI: process.env.REACT_APP_RESTAPI,
  socketAPI: process.env.REACT_APP_WEBSOCKETAPI,
  credenciamento: process.env.REACT_APP_CREDENCIAMENTO,
  credenciamentoAPI: process.env.REACT_APP_CREDENCIAMENTO_API,
}